import { getCurrentUser } from 'redux/query';

export const hasZppCourseAttendances = (state) => {
  const user = getCurrentUser(state);
  return (
    !!(user?.zppCourseAttendances || []).length &&
    user?.zppCourseAttendances.some((attendance) => attendance?.insuranceCompany && !!attendance?.insuranceCompany.slug)
  );
};
